<template>
	<Action
		v-if="blocked"
		title="Unblock"
		class="btn btn--green"
		@click="unblock"
		:disabled="updating"
	>
		<IconUnblock />
	</Action>
	<Action
		v-else
		title="Block"
		class="btn btn--red"
		@click="block"
		:disabled="updating"
	>
		<IconBlock />
	</Action>
</template>

<script>
import Action from '@/components/shared/Action'
import IconBlock from 'mdi-vue/Cancel'
import IconUnblock from 'mdi-vue/Undo'

export default {
	name: 'ToggleBlockAction',
	props: {
		blocked: Boolean,
		updating: Boolean
	},
	methods: {
		block() {
			this.$emit('block')
		},
		unblock() {
			this.$emit('unblock')
		}
	},
	components: {
		Action,
		IconBlock,
		IconUnblock
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.btn {
	&--red {
		color: $red-85;
	}
	&--green {
		color: $green-50;
	}
}
</style>
